module.exports = __webpack_public_path__ + "img/local.9a42e64c.svg";